import React from "react";
import Section from "../Section";
import Ventanamon from "../Ventanamon";

export default function HomeSection() {
  return (
    <Section index="0" letter="h" content={<Ventanamon/>}></Section>
  )
}